import type { Logger } from 'pino';

export const useClientConfig = (): any => {
  const config = useRuntimeConfig();
  return config.public.clientConfig;
};
